"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail__read__empty__state(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf701af4-9158-4268-9a05-b38eaedd3a1e",
    x1: 54.29,
    y1: 26.86,
    x2: 137.71,
    y2: 110.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "mail-read-empty-state-hi"), /*#__PURE__*/React.createElement("g", {
    id: "0b926c2e-6b9e-425b-989d-7609ca9b0708",
    "data-name": "mail-read-empty-state-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "499868ad-51d4-4b65-bd2a-6fd174879a81",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "659d16fe-5a9d-42b8-a809-1962e947e035",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea7fb327-afd6-49b9-9352-5b48db3851a1",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66c83a36-feb9-427e-b175-5b91c5b22eb2",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e5a63f9-0f6b-4a83-b51d-4eb4d97c394d",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "23010cc7-4c95-4c20-9a62-4ce47f71c0c8",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06878c4f-dc4a-4fff-a3f3-fa40d76b0519",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8ee2ff72-3ec0-4ebe-b901-a030568e017d",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28a28444-9c5b-4bca-ad20-f63fefca0012",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a331d80a-f8e1-4595-bdc7-e97f97c3317c",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa01a99f-eb22-4e8d-95eb-fd7b734f433b",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0a4dffd-aa06-4831-9dcc-7fb8efe06f2c",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8e29293-af93-46ef-9e1b-acdd8d0d5128",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d028a684-fee7-4f2a-83e2-01aa1542c2e6",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7cf8792c-2da8-46f7-bcfb-247b35169a23",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1f544ace-7af8-4caf-a82c-99ac77bbaad9",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "32ed259f-2e05-4fc0-a532-e002888bfa9e",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,116c-6.17,0-12-4-12-4L16,70v2l68,42s5.83,4,12,4,12-4,12-4l68-42V70l-68,42S102.17,116,96,116Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,118c-6.17,0-12-4-12-4L16,72v80a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V72l-68,42S102.17,118,96,118Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "3654e62d-41d5-41c2-9632-e15603678063",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,61.66,108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46V72l68,42s5.83,4,12,4,12-4,12-4l68-42V68.46A8,8,0,0,0,172.2,61.66Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#cf701af4-9158-4268-9a05-b38eaedd3a1e)"
  }))))))))))))))))))));
}

var _default = ic_mail__read__empty__state;
exports.default = _default;